export enum AccessTypes {
  petOwner,
  breeder,
  council,
  implanter,
  microchipSupplier,
  registery,
  vet,
  welfare
}
